import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AgreementType } from "@shared/enums/agreementType";
import { FormulasOptions } from "@shared/enums/formulas-options";
import { HouseType } from "@shared/enums/houseType";
import { PackagesType } from "@shared/enums/packages-type";
import { RiskItemInformations } from "@shared/enums/riskItemInformations";
import { DividerModule } from "primeng/divider";

@Component({
  selector: "app-options-list-pj",
  standalone: true,
  imports: [CommonModule, TranslateModule, DividerModule],
  templateUrl: "./options-list-pj.component.html",
})
export class OptionsListPJComponent implements OnInit {
  @Input() details!: any;
  hasValuableObject = false;

  options = FormulasOptions;
  packageType = PackagesType;
  agreementType = AgreementType;
  riskItemInfo = RiskItemInformations;
  houseType = HouseType;

  riskItemsToDisplay: { key: string; value: string; displayName: string }[] = [];

  isContract() {
    return this.details.bankInformationPolicyVm;
  }

  hasCode(item: any, code: string): boolean {
    return item.code === code;
  }

  ngOnInit(): void {
    this.formatRiskItemInfo();
  }

  formatRiskItemInfo() {
    const riskItemInfo = this.details.riskItemInformations.values;

    this.riskItemsToDisplay = riskItemInfo.map((i: any) => {
      return { key: i.code, value: i.value, displayName: `PJ_KEYS.${i.code}` };
    });
  }
}
